import { render, staticRenderFns } from "./AstroCalendarNoteCard.vue?vue&type=template&id=4a370ac5&scoped=true&"
import script from "./AstroCalendarNoteCard.vue?vue&type=script&lang=js&"
export * from "./AstroCalendarNoteCard.vue?vue&type=script&lang=js&"
import style0 from "./AstroCalendarNoteCard.vue?vue&type=style&index=0&id=4a370ac5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a370ac5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a370ac5')) {
      api.createRecord('4a370ac5', component.options)
    } else {
      api.reload('4a370ac5', component.options)
    }
    module.hot.accept("./AstroCalendarNoteCard.vue?vue&type=template&id=4a370ac5&scoped=true&", function () {
      api.rerender('4a370ac5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/共時曆/AstroCalendarNoteCard.vue"
export default component.exports